import type { ColumnGroupType, ColumnType, ColumnsType } from "antd/es/table";
import Table from "antd/es/table";
import { FC } from "react";

import { GetOrderInProgress } from "services/interface";

// ความกว้างรวมของตาราง (ใช้เป็น scroll.x) — column ที่ไม่กำหนด width จะยืดรับพื้นที่ที่เหลือ
// นับขั้นต่ำไว้ 220 ก่อนเริ่ม scroll แนวนอน
export const getScrollX = <T,>(columns: ColumnsType<T>) =>
  columns.reduce(
    (sum, col) => sum + (typeof col.width === "number" ? col.width : 220),
    0
  );

interface PointTableListProps {
  data: GetOrderInProgress[] | undefined;
  columns: ColumnsType<GetOrderInProgress>;
  total: number;
  current: number;
  pageSize: number;
  onPageChange: (page: number, pageSize: number) => void;
}

const PointTableList: FC<PointTableListProps> = ({
  data,
  columns,
  total,
  current,
  pageSize,
  onPageChange,
}) => {
  let filtersColumns: (
    | ColumnGroupType<GetOrderInProgress>
    | ColumnType<GetOrderInProgress>
  )[] = columns;

  return (
    <div>
      <Table
        rowKey="item_id"
        size="middle"
        columns={filtersColumns}
        scroll={{ y: 600, x: getScrollX(columns) }}
        dataSource={data}
        pagination={{
          current,
          pageSize,
          total,
          showSizeChanger: true,
          showTotal: (t) => `ทั้งหมด ${t} รายการ`,
          onChange: onPageChange,
        }}
      />
    </div>
  );
};

export default PointTableList;
